import { RG_TECH_CLASS } from "@project-rouge/rg-core";
function createGenericSpaceInstance() {
	return {
		name: "Generic Space",
		source: "Generic",
		spaceClass: RG_TECH_CLASS.Amenity,
		attributes: {},
		conditions: {}
	};
}
export { createGenericSpaceInstance };

//# sourceMappingURL=index102.js.map